module.exports = __webpack_public_path__ + "static/media/mmbank-small.2a382c98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mmbank-small.png
// module id = 521
// module chunks = 0